module.exports = __webpack_public_path__ + "img/logo-white.7ba8e4b.svg";